<mat-nav-list>
  <ng-container *ngFor="let menuItem of menuItems">
    <a *coaFeatureToggleEnable="menuItem.featureToggle; clientId: clientId"
       [queryParams]="{dateRange: dateRange}"
       [routerLinkActiveOptions]="{exact: false}"
       [routerLink]="['/clients', clientId, menuItem.url]"
       class="sidenav-item"
       mat-list-item
       routerLinkActive="sidenav-item--active">
      <div class="sidenav-item__content">
        <mat-icon class="sidenav-item__icon">{{menuItem.icon}}</mat-icon>
        <span *ngIf="showLabels" class="sidenav-item__label">{{menuItem.name}}</span>
      </div>
    </a>
  </ng-container>
</mat-nav-list>
